export const throttle = <T extends (...args: any[]) => any>(callback: T, delay: number) => {
  let throttlePause = false

  return (...args: Parameters<T>): ReturnType<T> | undefined => {
    if (throttlePause) {
      return
    }

    throttlePause = true

    // Execute callback immediately and capture result
    const result = callback(...args)

    // Schedule the throttle reset
    setTimeout(() => {
      throttlePause = false
    }, delay)

    return result
  }
}

export const debounce = <T extends (...args: any[]) => any>(callback: T, delay: number) => {
  let timeoutId: NodeJS.Timeout | undefined

  const debouncedFn = (...args: Parameters<T>): void => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => callback(...args), delay)
  }

  // Add cancel method to clear pending timeouts
  debouncedFn.cancel = () => {
    clearTimeout(timeoutId)
    timeoutId = undefined
  }

  return debouncedFn
}
